// eslint-disable-next-line import/prefer-default-export
export const PeriodType = Object.freeze({
    Days: 1,
    Weeks: 2,
});
